<script>
import NewsFilter from './NewsFilter.vue';
import NewsList from './NewsList.vue';
import moment from 'moment';
import VueLoading from 'vue-loading-overlay';

export default {
  components: {
    NewsFilter,
    NewsList,
    VueLoading,
  },
  props: ['url', 'request', 'componentTexts', 'tags'],
  data() {
    return {
      cPageIndex: 0,
      nPageIndex: 0,
      fetchUrl: '',
      news: [],
      promotedNewsItem: '',
      loading: false,
      loadingMore: false,
      pageIndex: 0,
      showFilter: false,
      selectedTags: [],
      filterText: this.componentTexts?.filterText?.value || '',
      groupsText: this.componentTexts?.groupsText?.value || '',
      showMoreText: this.componentTexts?.showMoreText?.value || '',
    };
  },
  mounted() {
    if (this.tags) {
      this.showFilter = true;
    }
    if (this.url && this.request) {
      this.fetchUrl = this.url;
      this.init(this.url, this.request);
    }
  },
  methods: {
    // Reinits and sends seleted tags with the request to backend
    handleSelectedTags(selectedTags) {
      let curReq = this.request;
      let request = {
        LanguageId: this.lang,
        NewsPageId: curReq.NewsPageId,
        PageSize: curReq.PageSize,
      };

      if (selectedTags.length > 0) {
        request.Tags = selectedTags;
      }

      // Clean news array
      this.news.splice(0);

      this.init(this.url, request);

      this.selectedTags = selectedTags;
    },
    async getMorePosts() {
      let newReq = this.request;
      newReq.PageIndex = this.nPageIndex;

      try {
        this.loadingMore = true;

        const response = await fetch(this.url, {
          method: 'post',
          headers: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json;charset=UTF-8',
          },
          body: JSON.stringify(newReq),
        });

        const data = await response.json();

        if (data) {
          if (data.Events && data.Events.length > 0) {
            await data.Events.map((event) => {
              event.PublishedDate = moment(event.PublishedDate)
                .locale(newReq.LanguageId)
                .format('dddd D MMMM YYYY');
            });

            this.news.push(...data.Events);
          }
          this.cPageIndex = data.CurrentPageIndex;
          this.nPageIndex = data.NextPageIndex;
        }

        this.loadingMore = false;
      } catch (error) {
        console.log(error);
        this.loadingMore = false;
      }
    },
    async init(url, req) {
      try {
        let lang = req.LanguageId;
        this.loading = true;
        const response = await fetch(url, {
          method: 'post',
          headers: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json;charset=UTF-8',
          },
          body: JSON.stringify(req),
        });
        const data = await response.json();
        if (data) {
          if (data.PromotedNewsItem) {
            data.PromotedNewsItem.PublishedDate = moment(
              data.PromotedNewsItem.PublishedDate
            )
              .locale(lang)
              .format('dddd D MMMM YYYY');
            this.promotedNewsItem = data.PromotedNewsItem;
          }
          if (data.Events && data.Events.length > 0) {
            await data.Events.map((event) => {
              event.PublishedDate = moment(event.PublishedDate)
                .locale(lang)
                .format('dddd D MMMM YYYY');
            });
            this.news.push(...data.Events);
          }
          this.lang = lang;
          this.cPageIndex = data.CurrentPageIndex;
          this.nPageIndex = data.NextPageIndex;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <div class="container mb-5 newspagecomponent vld-parent">
    <NewsFilter
      v-if="showFilter"
      :filter-text="filterText"
      :tags="tags"
      :loading="loading"
      @handle-selected-tags="handleSelectedTags" />
    <div class="d-flex align-items-center justify-content-center pb-2">
      <vloading
        :height="32"
        :width="32"
        :color="'#404040'"
        :is-full-page="false"
        :active.sync="loading"></vloading>
    </div>
    <NewsList
      v-if="news"
      :groups-text="groupsText"
      :show-more="showMoreText"
      :promoted-news-item="promotedNewsItem"
      :loading-more="loadingMore"
      :loading="loading"
      :news="news"
      :c-page-index="cPageIndex"
      :n-page-index="nPageIndex"
      @fetch-more="getMorePosts" />
  </div>
</template>
